import * as actionTypes from 'src/old/actions';

const initialState = { isLoading: undefined };

const loadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOADING_START: {
      return {
        ...state,
        isLoading: true
      };
    }
    case actionTypes.LOADING_DONE: {
      return {
        ...state,
        isLoading: false
      };
    }

    default: {
      return state;
    }
  }
};

export default loadingReducer;
